import script from "./BetBoosterComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./BetBoosterComponent.vue?vue&type=script&setup=true&lang=js"

import "./BetBoosterComponent.vue?vue&type=style&index=0&id=d51e4218&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d51e4218"]])

export default __exports__